import React, { useContext } from 'react';

import AppContext from '../context';

const GradeSelector = () => {
  const context = useContext(AppContext);

  const grades = ['K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'Post-Grad'];

  const selectGrade = grade => {
    const updatedFilters = { ...context.filters };
    updatedFilters.grade = grade;

    context.setFilters(updatedFilters);

    context.setStep(3);
    if (context.progress <= context.step) {
      context.setProgress(3);
    }
  }

  return (
    <div className="program-filter program-filter--left-aligned">
      {context.displayText ?
        <p>
          {context.displayText.grade_text ?
            <span>{ context.displayText.grade_text }</span>
          :
            <span>What grade is your camper starting?</span>
          }
        </p>
      : null}

      {grades.map((grade, index) =>
        <button
          key={index}
          className={`program-option program-option--grade ${context.filters.grade === grade ? 'selected' : ''}`}
          type="button"
          onClick={selectGrade.bind(this, grade)}
        >
          { grade }
        </button>
      )}
    </div>
  );
}

export default GradeSelector;